import type { ReactNode } from 'react';
import { SectionLabel } from '@wundo/ui';

/** One titled block of the debug dialog. */
export function DebugSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className='flex flex-col gap-2'>
      <SectionLabel as='h3'>{title}</SectionLabel>
      {children}
    </section>
  );
}

/** One fact in a section's list: its name, then its value. */
export function DebugRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className='flex gap-3 py-0.5'>
      <dt className='w-44 shrink-0 text-ink-muted'>{label}</dt>
      <dd className='min-w-0 flex-1 text-ink-body'>{children}</dd>
    </div>
  );
}
